import $ from "jquery";

const SELECTOR_CONTAINER = '[data-js="jsShowLimit"]';
const SELECTOR_TOGGLE = '[data-js="jsShowLimitToggle"]';
const SELECTOR_TOGGLE_MORE = '[data-js="jsShowLimitToggleMore"]';
const SELECTOR_TOGGLE_LESS = '[data-js="jsShowLimitToggleLess"]';
const TEMPLATE_MORE = "+ [count] more";
const TEMPLATE_LESS = "- Show less";

const handleClick = function handleClick(e) {
  e.preventDefault();
  const $el = $(e.currentTarget).closest(SELECTOR_CONTAINER);
  if ($el.data("is-expanded")) {
    showUpToLimit($el);
  } else {
    showAll($el);
  }
};

const addMoreText = function ($el) {
  const $lis = $el.find("li");
  const showLimit = $el.data("show-limit");
  const showDifference = $lis.length - showLimit;
  if ($lis.length > showLimit) {
    const textMore = TEMPLATE_MORE.replace("[count]", showDifference);
    const textLess = TEMPLATE_LESS;
    $el
      .find(SELECTOR_TOGGLE_MORE)
      .hide()
      .html(
        `<a href="#" aria-label="Show ${showDifference} more items">${
          textMore
        }</a>`,
      );
    $el
      .find(SELECTOR_TOGGLE_LESS)
      .hide()
      .html(
        `<a href="#" aria-label="Show ${showDifference} fewer items">${
          textLess
        }</a>`,
      );
  }
};

var showUpToLimit = function ($el) {
  // hide if more than limit
  $el.data("is-expanded", false);
  const showLimit = $el.data("show-limit");
  const $lis = $el.find("li");
  if ($lis.length > showLimit) {
    $lis.hide().attr("aria-hidden", "true");
    $lis.slice(0, showLimit).show().removeAttr("aria-hidden");
    $el.find(SELECTOR_TOGGLE_MORE).show();
    $el.find(SELECTOR_TOGGLE_LESS).hide();
  }
};

var showAll = function ($el) {
  // hide if more than limit
  $el.data("is-expanded", true);
  const showLimit = $el.data("show-limit");
  const $lis = $el.find("li");
  if ($lis.length > showLimit) {
    $lis.show().removeAttr("aria-hidden");
    $el.find(SELECTOR_TOGGLE_MORE).hide();
    $el.find(SELECTOR_TOGGLE_LESS).show();
  }
};

const init = function () {
  $(SELECTOR_CONTAINER).each(function () {
    addMoreText($(this));
    showUpToLimit($(this));
  });
};

$(document).on("click", SELECTOR_TOGGLE, handleClick);

$(function () {
  init();
});

$(document).on("storybook:component:change", function () {
  init();
});
